export default __webpack_public_path__ + "static/media/Q9_0_resized.35a8b134.jpg";